import {
    SEARCH_LEAD_COUNTY_REQUEST,
    SEARCH_LEAD_COUNTY_REQUEST_FAILURE,
    SEARCH_LEAD_COUNTY_REQUEST_SUCCESS,
} from '../constants/search_lead_county.constants';
import {
    GET_BIKE_BRANDS_REQUEST,
    GET_BIKE_BRANDS_SUCCESS,
    GET_BIKE_BRANDS_FAILURE,
} from '../constants/get_bike_brands.constants';
import {
    GET_BIKE_MODELS_LEAD_CREATE_REQUEST,
    GET_BIKE_MODELS_LEAD_CREATE_REQUEST_SUCCESS,
    GET_BIKE_MODELS_LEAD_CREATE_REQUEST_FAILURE,
} from '../constants/get_bike_models.constants';
import {
    GET_BIKE_VARIANTS_REQUEST,
    GET_BIKE_VARIANTS_SUCCESS,
    GET_BIKE_VARIANTS_FAILURE,
} from '../constants/get_bike_variants.constants';
import {
    GET_BIKES_FOR_PART_EX_SUCCESS,
    GET_BIKES_FOR_PART_EX_FAILURE,
} from '../constants/get_bikes_for_part_ex.constants';
import {
    CREATE_LEAD_REQUEST,
    CREATE_LEAD_SUCCESS,
    CREATE_LEAD_FAILURE,
} from '../constants/create_lead.constants';
import {
    LEAD_CREATE_COUNTY_CREATE_REQUEST,
    LEAD_CREATE_COUNTY_CREATE_SUCCESS,
    LEAD_CREATE_COUNTY_CREATE_FAILURE,
} from '../constants/lead_create_county_create.constants';

import { setVal } from '../../../../../shared/helpers';
import { reduxSetter } from '../../../../../utils/reduxSetter';

const initialState = {
    bikeInfoIsLoading: false,
    loading: false,
    error: null,
    counties: { filters: { searchText: '' }, data: [] },
    brands: { filters: { searchText: '' }, data: [] },
    models: { filters: { searchText: '' }, data: [] },
    variants: { filters: { searchText: '' }, data: [] },
    bikes_for_part_ex: { filters: { searchText: '' }, data: [] },
    bike_info_by_vrm: {
        loading: false, showModal: false, data: {}, error: false,
    },
    create_new_county: { loading: false },
    catalogs: {
        lead_source: {
            isLoading: true,
            error: null,
            data: [],
        },
    },
};

export const Lead_create = (state = initialState, action) => {
    switch (action.type) {
    case 'SET_LEAD_CREATE_DATA':
        return reduxSetter(state, action);
    case 'SET_FILTER':
        return setVal(state, action.path, action.value);

    case CREATE_LEAD_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case CREATE_LEAD_SUCCESS:
        return {
            ...state,
            loading: false,
        };
    case CREATE_LEAD_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.error,
        };

    case LEAD_CREATE_COUNTY_CREATE_REQUEST:
        return {
            ...state,
            create_new_county: {
                loading: true,
            },
        };
    case LEAD_CREATE_COUNTY_CREATE_SUCCESS:
        return {
            ...state,
            loading: false,
            create_new_county: {
                loading: false,
                data: action.payload,
            },
        };
    case LEAD_CREATE_COUNTY_CREATE_FAILURE:
        return {
            ...state,
            create_new_county: {
                loading: false,
            },
            error: action.error,
        };

    case GET_BIKE_BRANDS_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case GET_BIKE_BRANDS_SUCCESS:
        return {
            ...state,
            loading: false,
            brands: {
                ...state.brands,
                data: action.payload,
            },
        };
    case GET_BIKE_BRANDS_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.error,
        };
    case GET_BIKE_MODELS_LEAD_CREATE_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case GET_BIKE_MODELS_LEAD_CREATE_REQUEST_SUCCESS:
        return {
            ...state,
            loading: false,
            models: {
                ...state.models,
                data: action.payload,
            },
        };
    case GET_BIKE_MODELS_LEAD_CREATE_REQUEST_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.error,
        };

    case GET_BIKE_VARIANTS_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case GET_BIKE_VARIANTS_SUCCESS:
        return {
            ...state,
            loading: false,
            variants: {
                ...state.variants,
                data: action.payload,
            },
        };
    case GET_BIKE_VARIANTS_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.error,
        };


    case GET_BIKES_FOR_PART_EX_SUCCESS:
        return {
            ...state,
            loading: false,
            bikes_for_part_ex: {
                ...state.bikes_for_part_ex,
                data: action.payload,
            },
        };
    case GET_BIKES_FOR_PART_EX_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.error,
        };

    case SEARCH_LEAD_COUNTY_REQUEST:
        return {
            ...state,
        };
    case SEARCH_LEAD_COUNTY_REQUEST_SUCCESS:
        return {
            ...state,
            counties: {
                ...state.counties,
                data: action.payload,
            },
        };
    case SEARCH_LEAD_COUNTY_REQUEST_FAILURE:
        return {
            ...state,
            error: action.error,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/reducers/lead_create.reducers.js